import { MessageCircle } from 'lucide-react';

export default function WhatsAppButton() {
  const phoneNumber = '556130413218'; // From the provided contact info
  const message = 'Olá, gostaria de suporte com a Telemedicina Novità.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-emerald-500 text-white rounded-full shadow-lg hover:bg-emerald-600 transition-all transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-emerald-300"
      aria-label="Suporte via WhatsApp"
    >
      <MessageCircle className="w-8 h-8" />
    </a>
  );
}
